<div class="rightside-panel">
  <div class="top_heading">
    <div class="col-1 text-left icn" (click)="handleGoback()"><span>&#10094;</span>Back</div>
    <div class="col-10">Cover/Support letter elements/attributes</div>

  </div>
  <div class="p-3 mt-3">
    <p-pickList styleClass="vd-picklist" [responsive]="true" [source]="defaultElementList"
      [target]="selectedElementList" dragdrop="true" sourceHeader="Related Cover/Support letter elements/attributes"
      targetHeader="Selected elements/attributes" [style]="{'width': '100%'}" [showSourceControls]="false"
      [showTargetControls]="false" [sourceStyle]="{'height':'40rem'}" [targetStyle]="{'height':'40rem'}" filterBy="name"
      sourceFilterPlaceholder="Search by name" (onMoveToTarget)="selectedCatagory($event)"
      (onMoveAllToTarget)="selectedCatagory($event)">
      <ng-template pTemplate="emptymessagetarget">
        <div class="row">
          <div class="col-12"><small>No Elements/attributes are selected yet.</small></div>
          <div class="col-12"><small>Add the Elements/attributes to the bucket to proceed</small></div>
        </div>
      </ng-template>
      <ng-template let-catagory pTemplate="item">
        <div class="row">
          <div class="col-10">{{catagory?.description}}</div>

        </div>
      </ng-template>
    </p-pickList>
  </div>
</div>
<div class="mt-4">
  <p-divider type="dashed"></p-divider>
</div>
<div class="buttonContainer my-2">
  <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="handleGoback()">GO BACK</button></div>
  <div> <button type="submit" class="btn vdCreateBtn mr-3" (click)="handleSaveStep()" *ngIf="isEditVisa">SAVE</button></div>
</div>